module.exports = {
  en_title: "CONTACT US",
  en_title_description: "Contact for more information",
  en_description:
    "Contact the Auto Rebalance team for information. We will contact you as soon as possible.",
};
